// extracted by mini-css-extract-plugin
module.exports = {"browseHeading":"browse-heading_browseHeading__fx8ZF"};